import { render, staticRenderFns } from "./InstitutionFilters.vue?vue&type=template&id=2a533b22&scoped=true&"
import script from "./InstitutionFilters.vue?vue&type=script&lang=js&"
export * from "./InstitutionFilters.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/filters.css?vue&type=style&index=0&id=2a533b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a533b22",
  null
  
)

export default component.exports